import { useEffect } from 'react';

import { setCustomerViewProperty } from '@/config/mixpanel';

import { useStaffView } from './useStaffView';

export const useCustomerViewAnalytics = () => {
  const { isCustomerView } = useStaffView();

  useEffect(() => {
    setCustomerViewProperty(isCustomerView);
  }, [isCustomerView]);
};
